export default __webpack_public_path__ + "static/media/task_prescription_report_icon.56f1b259.svg";